<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="add()">新增</Button>
		</div>
		<div class="query">
			<div class="checkbox">
				<!-- <Select v-model="appType" style="width:200px" @on-change='onchange'>
					<Option v-for="item in appTypes" :value="item.value" :key="item.value">{{ item.label }}</Option>
				</Select> -->
			</div>
			<Input search enter-button placeholder="请输入广告投放商名称查询" style="width: 500px;" v-model="query.like" @on-blur="likeQuery" />
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="update(row.id)">详情</Button>
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				appType:'',
				appTypes:[
					{value:"",label:'后台管理app'},
					{value:"HOUTAIANDROID",label:'后台管理app-安卓'},
					{value:"HOUTAIIOS",label:'后台管理app-IOS'},
				],
				loading: false,
				total: 0,
				query: { //查询参数
					page: 0,
					size: 10,
					appType: ''
				},
				modal2: false,
				modal_loading: false,
				deleteId: '',
				columns12: [{
						type: 'selection',
						width: 60,
						align: 'center'
					}, {
						title: 'id',
						key: 'id'
					},
					{
						title: '是否必须更新',
						key: 'mustName'
					},
					{
						title: '版本号',
						key: 'number'
					},
					{
						title: '更新内容',
						key: 'remark'
					},
					{
						title: '类型',
						key: 'appTypeName'
					},
					{
						title: '下载地址',
						key: 'url'
					},
					{
						title: '录入人',
						key: 'empName'

					},
					{
						title: '录入时间',
						key: 'createdTime'
					},
					{
						title: '操作',
						slot: 'action',
						width: 100,
						align: 'center'
					}
				],
				data6: [
					/* 	{
						id: '1',
						companyName: '',
						address: '',
						phone1: '',
						phone2: '',
						phone3: '',
						mailbox: '',
						operType: '',
						state: '',
						createdTime: '2010-10-10'

					}, */
				]

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			onchange(){
				let _this=this
				this.query.page=0
				_this.query.appType=_this.appType
				_this.ajaxPage()
			},
			update(id) { //修改
				this.$router.push({
					name: 'jm/admin/appVersions/update',
					query: {
						id: id
					}
				})
			},
			forbidden(id) {
				this.deleteId = id
				this.modal2 = true
			},
			add() {
				this.$router.push({
					name: 'jm/admin/appVersions/add'
				})
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			likeQuery() {

				this.query.page=0
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/app/vesions/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.platVersions.totalElements
						_this.data6 = data.platVersions.content
						
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}

		},
		components: {
			page
		},
		created() {
			this.ajaxPage();
		}


	}
</script>
<style scoped="scoped">
	.ivu-table-cell {
		padding-left: 0px !important;
	}

	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.ivu-table-cell {
		padding-left: 0px;
	}

	.query {
		display: flex;
		justify-content: space-between;
		margin: 20px 0px 20px 0px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/android/versions/list2.vue